import { atom } from 'jotai'

export const isPartialApproveSelectedByUserAtom = atom<boolean>(false)
